import React, { useRef, useState, } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../../assets/css/login.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Card } from 'primereact/card';
import { InputText } from "primereact/inputtext";
import { Button } from 'primereact/button';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import axios from 'axios';
import config from '../../config';
import { useClientAuth } from '../../context/ClientAuthContext';
import { armOnboardingTrigger, startOnboardingChain } from '../../components/onboarding/onboardingStorage';

const Client_login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { login } = useClientAuth();
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const handlePasswordViewToggle = () => {
    setShowPassword(!showPassword);
  };


  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    try {
      const response = await axios.post(`${config.apiBASEURL}/ClientAuthRoutes/Client-login`, {
        email,
        password
      });

      const authData = response.data;
      // Call login to save user data locally (e.g., session storage)
      login(authData);

      // Arm the onboarding tour so it auto-starts once the dashboard mounts.
      // Session-scoped: won't repeat again this browser session once completed/skipped.
      armOnboardingTrigger('client');
      startOnboardingChain();

      // Redirect based on role immediately
      switch (authData.role) {
        case 'Client':
          navigate('/Client/dashboard/Client_home', { state: { role: authData.role } });
          break;
        default:
          navigate('/Client/', { state: { role: authData.role } });
          break;
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setErrorMessage(error.response.data.message);
      } else {
        setErrorMessage('An error occurred. Please try again.');
      }
    }
  };



  return (
    <Container className='login-card clientlog'>
      <Row className="mx-0 justify-content-start">
        <Col md='6' lg='3' className='w-440'>
          <Card title="Login" className='shadow-lg border'>
            <p className='login_logo'>
              <img src={require("../../assets/images/logogf.png")} alt="Logo" style={{ width: '30px', height: '30px' }} />Blackbox
            </p>
            <form className='mt-4' onSubmit={handleLogin}>
              <Col className='mb-3'>
                <label htmlFor="email"><i className='pi pi-envelope pe-2'></i>Email</label>
                <InputText
                  type="email"
                  name="email"
                  placeholder="Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Col>
              <Col className='mb-3'>
                <label htmlFor="password">
                  <i className='pi pi-lock pe-2'></i>Password
                </label>
                <div style={{ position: 'relative' }}>
                  <InputText
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    onClick={handlePasswordViewToggle}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      cursor: 'pointer'
                    }}
                  >
                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                  </span>
                </div>
              </Col>
              {errorMessage && <p className='text-danger mt-2'>{errorMessage}</p>}
              <Col>
                <p className='mt-4 text-end w-100'><Link to='/Client/passreset'>Forgot password?</Link></p>
              </Col>
              <Col className='d-flex justify-content-center mt-4'>
                <Button label="Login" type="submit" className='loginbtn' />
              </Col>
            </form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Client_login;